import Tabs from '../includes/tabs.js';

export default function() {
	const page = document.getElementById('company-profile');
	const symbol = page.dataset.symbol;

	const navTabs = Tabs.init(document.getElementById('company-profile-nav'), async opts => {
		const response = await ajax('loadCompanyProfileTab', { symbol, tab: opts.tab });
		
		return response.html;
	});

	const contentTabs = Tabs.init(document.getElementById('company-profile-content'));
}
